import React from 'react';
import styled from 'styled-components';

import { Attachment, Emoji } from './shared/editor_action_buttons';
import CharacterCount from 'components/text_editor/character_count';
import Composer, { Header, HeaderText, useComposer } from './shared/composer';
import { EditorContainer, useEditor } from './shared/editor';
import MessagingEditor from './editors/messaging';
import PlaintextSerializer from 'components/text_editor/serializers/plaintext_serializer';
import SendFbMessage from 'actions/composer/send_fb_message';

export function FbMessengerComposer() {
  const composer = useComposer(SendFbMessage);
  const editorProps = useEditor('messageHtml', composer, { attr: 'body', serializer: PlaintextSerializer });
  const [composerProps] = composer;

  return (
    <Composer includeAttachments submitText="Send" {...composerProps}>
      <Header>
        <Left>
          <HeaderText color="green400">Messenger</HeaderText>
        </Left>
        <Right>
          <Emoji {...editorProps} />
          <Attachment alwaysShow />
        </Right>
      </Header>

      <EditorContainer includeAttachments>
        <MessagingEditor placeholder="Type to Respond" {...editorProps} />
        <CharacterCount {...editorProps} />
      </EditorContainer>
    </Composer>
  );
}

const Left = styled.div`
  align-items: center;
  display: flex;
  flex-grow: 1;
`;
const Right = styled.div`
  align-items: center;
  display: flex;
`;

export default FbMessengerComposer;
